import React from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Modal,
  ModalBody,
  PopoverBody,
  PopoverHeader,
  UncontrolledPopover,
} from 'reactstrap';

import NotificationMenuItem from './NotificationMenuItem';

class NotificationIcon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addFriendModal: false,
      user_from: null,
      request: null,
    };
  }

  dismissAll = () => {
    this.props.notificationsMessagesSeen(this.props.userNotifications);
  };

  openAddFriendModal = (user, id) => {
    this.setState({ addFriendModal: true, user_from: user, request: id });
    this.props.openNotificationMenu();
  };

  closeAddFriendModal = () => {
    this.setState({ addFriendModal: false, user_from: null, request: null });
  };

  submitFriendRequestResponse = (status) => {
    this.props.resolveFriendRequest(this.state.request, status);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.resolveFriendRequestSuccess) {
      this.closeAddFriendModal();
      this.props.setResolveFriendRequestSuccess(false);
      this.props.getFriendRequestNotifications();
    }

    if (nextProps.resolveFriendRequestMessage.text !== '') {
      this.hideMessage(this.props.setResolveFriendRequestMessage);
    }
  }

  hideMessage = (functionParam) => {
    setTimeout(() => {
      functionParam({ type: 'success', text: '' });
    }, 3000);
  };

  renderNotificationCard = (notification, index) => (
    <NotificationMenuItem
      {...notification}
      key={index}
      openAddFriendModal={this.openAddFriendModal}
      user={this.props.user}
      notificationsMessagesSeen={this.props.notificationsMessagesSeen}
    />
  );

  render() {
    let user_from_name = '';
    if (this.state.user_from) {
      user_from_name =
        this.state.user_from.username && this.state.user_from.username !== ''
          ? this.state.user_from.username
          : this.state.user_from.lastName;
    }
    return (
      <>
        <Button
          color="link"
          id="NotificationMenu"
          className="notification-bell mr-0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className={
              this.props.userNotifications.length +
                this.props.notificationByFriend.length >
              0
                ? 'svgAnimation'
                : null
            }
          >
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" />
          </svg>
          {this.props.hasAlert ? (
            <div
              className={
                this.props.userNotifications.length +
                  this.props.notificationByFriend.length <
                10
                  ? 'badge badgeContainer'
                  : 'badge badgeContainerMoreTen'
              }
            >
              {this.props.userNotifications.length +
                this.props.notificationByFriend.length <
              100
                ? this.props.userNotifications.length +
                  this.props.notificationByFriend.length
                : '+99'}
            </div>
          ) : (
            ''
          )}
        </Button>
        <UncontrolledPopover
          isOpen={this.props.showNotificationMenu}
          placement="bottom"
          target="NotificationMenu"
          trigger="hover"
          toggle={this.props.openNotificationMenu}
        >
          <PopoverHeader tag="div" className="d-flex flex-row">
            <span className="unread-count-modal mr-2">
              {this.props.userNotifications.length +
                this.props.notificationByFriend.length}
            </span>
            <b>Notifications</b>
            <Button
              color="link"
              onClick={this.dismissAll}
              className="btn-sm ml-auto m-0 p-0"
            >
              DISMISS ALL
            </Button>
          </PopoverHeader>

          <PopoverBody>
            {this.props.notificationByFriend?.map((notification, index) =>
              this.renderNotificationCard(notification, index),
            )}
            {this.props.userNotifications?.map((notification, index) =>
              this.renderNotificationCard(notification, index),
            )}
          </PopoverBody>
          <div className="popover-footer">
            <Link to="/app/notifications">
              <div>
                {this.props.userNotifications.length > 0 ? 'VIEW ALL' : ''}
              </div>
            </Link>
          </div>
        </UncontrolledPopover>
        {this.state.user_from && (
          <Modal
            isOpen={this.state.addFriendModal}
            toggle={this.closeAddFriendModal}
            className="add-friend-modal"
          >
            <div className="add-friends-header">
              <i className="icon-close" onClick={this.closeAddFriendModal} />
              {this.state.user_from.imgUrl && (
                <img
                  src={this.state.user_from.imgUrl}
                  alt="profile"
                  className="profile-image"
                  height="200"
                  width="200"
                />
              )}
              {!this.state.user_from.imgUrl && (
                <div className="profile-image-container">
                  <i className="icon-profile avatar-icon" />
                </div>
              )}
            </div>
            <div className="gradient-divider" />
            <ModalBody>
              <div className="notification-title">
                {`${user_from_name} wants to add you as a friend!`}
              </div>
              <div className="notification-description">
                Accepting friend invitations will allow you to see how you
                compare to your friends on the leaderboard.
              </div>
              <button
                disabled={this.props.resolveFriendRequestWaiting}
                className="btn btn-block rounded-sm add-friend-btn add-friend-btn-accept"
                onClick={() => this.submitFriendRequestResponse('accepted')}
              >
                accept
              </button>
              <button
                disabled={this.props.resolveFriendRequestWaiting}
                className="btn btn-block rounded-sm add-friend-btn add-friend-btn-decline"
                onClick={() => this.submitFriendRequestResponse('declined')}
              >
                decline
              </button>
              {this.props.resolveFriendRequestMessage.text !== '' &&
                this.props.resolveFriendRequestMessage.type === 'error' && (
                  <div className="message-error">
                    {this.props.resolveFriendRequestMessage.text}
                  </div>
                )}
            </ModalBody>
          </Modal>
        )}
      </>
    );
  }
}

export default NotificationIcon;
